/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import { userID, showAlert, showPriceValue } from "../Settings/Settings";
var module = "sale/";
var moduleName = "Sale";
class Form extends Component {
  constructor(props) {
    super(props);
    var saleID = this.props.match.params?.saleID || "";
    console.log(this.props.match, "this.props.match");
    var invoicetype =
      this.props.match.path === "/sale/invoice/:saleID/history"
        ? "history"
        : "";

    this.state = {
      userID: userID(),
      saleID: saleID,
      invoicetype: invoicetype,
      postdata: "",
      detaildata: [],
      pageloading: false,
    };
  }

  componentDidMount() {
    $("body").css("background", "#FFF");

    if (this.state.saleID !== "") {
      var params = {
        params:
          "&userID=" +
          this.state.userID +
          "&detail_id=" +
          this.state.saleID +
          "&type=" +
          this.state.invoicetype,
        url: module + "invoice",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.detaildata !== nextProps.detaildata &&
      nextProps.detaildata !== "" &&
      typeof nextProps.detaildata !== undefined &&
      typeof nextProps.detaildata !== "undefined" &&
      this.state.editID !== ""
    ) {
      if (nextProps.detaildata.length > 0) {
        this.setState({ detaildata: nextProps.detaildata }, function () {
          if (nextProps.detaildata[0].status === "ok") {
            var result = nextProps.detaildata[0].result;

            var clientupdatedata = {
              saleNumber: result.saleNumber,
              invoiceNo: result?.salehistoryDetails?.saleInvoice,
              startDate: result.startDate,
              customer: {
                value: result.customerID,
                customerID: result.customerID,
                customerName: result.customerName,
                customerAddress1: result.customerAddress1,
                customerAddress2: result.customerAddress2,
                customerState: result.customerState,
                customerBranch: result.customerBranch,
                customerPincode: result.customerPincode,
                customerContactPerson: result.customerContactPerson,
                customerMobile: result.customerMobile,
                customerEmail: result.customerEmail,
                customerGSTNo: result.customerGSTNo,
                customerGSTCode: result.customerGSTCode,
              },
              typeofsale:
                result.saleType !== "Hardware"
                  ? { label: result.saleType, value: result.saleType }
                  : "",
              priviousTypeOfSale: result.saleType,
              brandID: "",
              warranty: "",
              salePaymentTerms: result.salePaymentTerms,
              products: result.salItem,
              taxItem: result.taxItem,
              totalPrice: result.salePrice,
              endDate:
                result.endDate !== ""
                  ? format(new Date(result.endDate), "dd-MM-yyyy")
                  : "",
              totalItem: result.totalItem,
              totalAmountWord: result.totalAmountWord,
              totalTaxAmount: result.totalTaxAmount,
              totalSingleTaxAmount: result.totalSingleTaxAmount,
              totalTaxAmountWord: result.totalTaxAmountWord,
              saleDeliveryNote: result.saleDeliveryNote,
              saleBuyerOrderNo: result.saleBuyerOrderNo,
              saleBuyerOrderDate:
                result.saleBuyerOrderDate !== "" && result.saleBuyerOrderDate!=='0000-00-00'
                  ? format(new Date(result.saleBuyerOrderDate), "dd-MM-yyyy")
                  : "",
              saleTermsofDelivery: result.saleTermsofDelivery,
            };
            this.setState(
              {
                postdata: clientupdatedata,
                pageloading: false,
              },
              () => {
                setTimeout(() => {
                  window.print();
                  window.onfocus = function () {
                    window.close();
                  };
                }, 100);
              }
            );
          } else {
            this.setState({ pageloading: false }, () => {
              this.props.history.push("/" + module);
              showAlert("Error", "Invalid" + moduleName, "error");
            });
          }
        });
      }
    }
  }

  render() {
    var postdata = this.state.postdata;
    var customerState = postdata?.customer?.customerState?? '';

    return (
      <div>
        {postdata !== "" && (
          <Helmet>
            <meta charSet="utf-8" />
            <title>ResMax Power Tech - Invoice No: {postdata?.invoiceNo}</title>
          </Helmet>
        )}
        <div className="print-a4 container print-invoice">
          <div className="align-center">
            <h3>Tax Invoice</h3>
          </div>
          <table className="parant-tbl">
            <tr>
              <td>
                <table>
                  <tr>
                    <td width="50%">
                      <table className="addres-tbl">
                        <tr>
                          <td>
                            <div style={{ marginLeft: "3px" }}>
                              <b>RESMAX POWER TECH</b>
                              <br />
                              #17, Ground Floor, 40 Feet Road, KGF Munireddy
                              Layout, Mahadevapura, Bangalore- 560048
                              <br />
                              Recepient ID (K2) - 2903608503
                              <br />
                              GSTIN/UIN : 29AAZFR4823M1Z6
                              <br />
                              State Name : Karnataka, Code :29
                              <br />
                              GSTIN/UIN: 29AAZFR4823M1Z6
                              <br />
                              E-Mail : resmax@resmax.in
                              <br />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div style={{ marginLeft: "3px" }}>
                              Consignee (Ship to)
                              <br />
                              <b>{postdata?.customer?.customerName}</b>
                              <br />
                              {postdata?.customer?.customerAddress1},{" "}
                              {postdata?.customer?.customerAddress2} -{" "}
                              {postdata?.customer?.customerPincode}
                              <br />
                              Ph No: {postdata?.customer?.customerMobile}
                              <br />
                              GSTIN/UIN : {postdata?.customer?.customerGSTNo}
                              <br />
                              State Name : {postdata?.customer?.customerState},
                              Branch : {postdata?.customer?.customerBranch},
                              Code : {postdata?.customer?.customerGSTCode}
                            </div>
                          </td>
                        </tr>
                        <tr className="no-border-bottom">
                          <td className="no-border-top">
                            <div style={{ marginLeft: "3px" }}>
                              Buyer (Bill to)
                              <br />
                              <b>{postdata?.customer?.customerName}</b>
                              <br />
                              {postdata?.customer?.customerAddress1},{" "}
                              {postdata?.customer?.customerAddress2} -{" "}
                              {postdata?.customer?.customerPincode}
                              <br />
                              Ph No: {postdata?.customer?.customerMobile}
                              <br />
                              GSTIN/UIN : {postdata?.customer?.customerGSTNo}
                              <br />
                              State Name : {postdata?.customer?.customerState},
                              Branch : {postdata?.customer?.customerBranch},
                              Code : {postdata?.customer?.customerGSTCode}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                    <td width="50%" valign="top">
                      <table className="invoice-tbl">
                        <tr>
                          <td>
                            Invoice No.
                            <br />
                            <b>{postdata?.invoiceNo}</b>
                          </td>
                          <td className="no-border-top">
                            Dated
                            <br />
                            <b>{postdata.startDate}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Delivery Note
                            <br />
                            <b>{postdata.saleDeliveryNote}</b>
                          </td>
                          <td>
                            Mode/Terms of Payment
                            <br />
                            <b>{postdata?.salePaymentTerms}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Buyer's Order No.
                            <br />
                            <b>{postdata.saleBuyerOrderNo}</b>
                          </td>
                          <td>
                            Dated
                            <br />
                            <b>{postdata.saleBuyerOrderDate}</b>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="no-border-bottom">
                            Terms of Delivery
                            <br />
                            <b>{postdata.saleTermsofDelivery}</b>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <table className="invoice-item">
                  <thead>
                    <tr>
                      <th style={{ width: "2%" }} className="no-border-left">
                        SI No.
                      </th>
                      <th style={{ width: "57%" }}>Description of Goods</th>
                      <th style={{ width: "10%" }}>HSN/SAC</th>
                      <th style={{ width: "8%" }}>Quantity</th>
                      <th style={{ width: "10%" }}>Rate</th>
                      <th style={{ width: "10%" }} className="no-border-right">
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {postdata?.products &&
                      postdata?.products.length > 0 &&
                      postdata?.products.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td valign="top" className="no-border-left">
                              {parseInt(index) + 1}
                            </td>
                            <td>
                              <b>{item.product.label}</b>
                              {item.description && (
                                <div style={{ marginLeft: "20px" }}>
                                  {item.description}
                                </div>
                              )}
                            </td>
                            <td valign="top">{item.productHSNSAC}</td>
                            <td align="right" valign="top">
                              {item.qty} No
                            </td>
                            <td align="right" valign="top">
                              {item.price}
                            </td>
                            <td
                              align="right"
                              valign="top"
                              className="no-border-right"
                            >
                              {item.totalPrice}
                            </td>
                          </tr>
                        );
                      })}
                    {postdata?.taxItem &&
                      postdata?.taxItem.length > 0 &&
                      postdata?.taxItem.map((item, index) => {
                        return (
                            <React.Fragment key={index}>
                              {((customerState).toLowerCase()==="karnataka") && (
                              <tr key={index}>
                                <td className="no-border-left"></td>
                                <td align="right">
                                  <b>Output CGST {parseFloat(item.saleItemTax)/2}%</b>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="right" className="no-border-right">
                                  {parseFloat(parseFloat(item.saleItemTaxPrice)/2).toFixed('2')}
                                </td>
                              </tr>)}
                              <tr key={index}>
                                <td className="no-border-left"></td>
                                <td align="right">
                                  <b>Output SGST {parseFloat(item.saleItemTax)/2}%</b>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td align="right" className="no-border-right">
                                  {parseFloat(parseFloat(item.saleItemTaxPrice)/2).toFixed('2')}
                                </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td className="no-border-left"></td>
                      <td align="right">Total</td>
                      <td></td>
                      <td align="right">{postdata?.totalItem} No</td>
                      <td></td>
                      <td align="right" className="no-border-right">
                        {showPriceValue(postdata?.totalPrice)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <table>
                  <tr>
                    <td>
                      Amount Chargeable (in words)
                      <br />
                      <strong>{postdata?.totalAmountWord}</strong>
                    </td>
                    <td align="right" valign="top">
                      E. & O.E
                    </td>
                  </tr>
                </table>
                <table className="tax-amt">
                  <thead>
                    <tr>
                      <th rowSpan={2} className="no-border-left"></th>
                      <th rowSpan={2}>Taxable Value</th>
                      {((customerState).toLowerCase()==="karnataka") && (
                        <th colSpan={2}>CGST</th>
                      )}
                      <th colSpan={2}>SGST/UTGST</th>
                      <th rowSpan={2} className="no-border-right">
                        Total Amount
                      </th>
                    </tr>
                    <tr>
                      {((customerState).toLowerCase()==="karnataka") && (
                        <>
                          <th className="no-border-left"></th>
                          <th>Rate</th>
                        </>
                      )}
                      <th>Amount</th>
                      <th>Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {postdata?.taxItem &&
                      postdata?.taxItem.length > 0 &&
                      postdata?.taxItem.map((item, index) => {
                        return (
                          <tr key={index}>
                            <td className="no-border-left"></td>
                            <td align="right">{item.taxableValue}</td>
                            {((customerState).toLowerCase()==="karnataka") && (
                              <>
                                <td align="right">{parseFloat(item.saleItemTax)/2}%</td>
                                <td align="right">{item.singleTaxAmt}</td>
                              </>
                            )}
                            <td align="right">{parseFloat(item.saleItemTax)/2}%</td>
                            <td align="right">{item.singleTaxAmt}</td>
                            <td className="no-border-right" align="right">
                              {item.saleItemTaxPrice}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                  <tfoot>
                    <tr style={{ fontWeight: "bold" }}>
                      <td className="no-border-left" align="right">
                        Total
                      </td>
                      <td align="right">{postdata?.salePrice}</td>
                      {((customerState).toLowerCase()==="karnataka") && (
                        <>
                        <td></td>
                        <td align="right">{postdata?.totalSingleTaxAmount}</td>
                        </>
                      )}
                      <td></td>
                      <td align="right">{postdata?.totalSingleTaxAmount}</td>
                      <td className="no-border-right" align="right">
                        {postdata?.totalTaxAmount}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <table>
                  <tr>
                    <td>
                      Tax Amount (in words) :{" "}
                      <strong>{postdata?.totalTaxAmountWord}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      Company's Bank Details
                      <table>
                        <tr>
                          <td>Bank Name</td>
                          <td>:</td>
                          <td>
                            <strong>ICICI Bank</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>A/c No.</td>
                          <td>:</td>
                          <td>
                            <strong>016905015845</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Branch & IFS Code</td>
                          <td>:</td>
                          <td>
                            <strong>INDRANAGAR & ICIC0000169</strong>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%" }}>
                      <div style={{ marginLeft: "5px" }}>
                        <u>Declaration</u>
                        <br />
                        We declare that this invoice shows the actual price of
                        the goods described and that all particulars are true
                        and correct.
                      </div>
                    </td>
                    <td>
                      Company's Bank Details
                      <table className="signatory-tbl">
                        <tr>
                          <td align="right">
                            for <strong>RESMAX POWER TECH</strong>
                          </td>
                        </tr>
                        <tr>
                          <td align="right">
                            <div style={{ marginTop: "30px" }}>
                              Authorised Signatory
                            </div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <div className="align-center">
            This is a Computer Generated Invoice
          </div>
        </div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);
